import React, { useEffect, useRef } from 'react';
import $ from 'jquery';
import 'daterangepicker';
import moment from 'moment';
import 'daterangepicker/daterangepicker.css';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { CalendarIcon } from '../../icons';

const DateRangePicker = ({ onDateChange }) => {
  const buttonRef = useRef(null);
  const pickerRef = useRef(null);

  useEffect(() => {
    const $btn = $(buttonRef.current);
    const start = moment();
    const end = moment();

    function updatePreview(start, end) {
      $btn.find('.js-daterangepicker-predefined-preview').html(
        start.format('MMM D') + ' - ' + end.format('MMM D, YYYY')
      );
      if (onDateChange) {
        onDateChange({ start, end }); // 🔥 Send selected dates to parent
      }
    }

    $btn.daterangepicker(
      {
        startDate: start,
        endDate: end,
        maxDate: moment(),
        autoUpdateInput: false,
        opens: 'left',
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          'Last 7 Days': [moment().subtract(6, 'days'), moment()],
          'Last 30 Days': [moment().subtract(29, 'days'), moment()],
          'This Month': [moment().startOf('month'), moment().endOf('month')],
          'Last Month': [
            moment().subtract(1, 'month').startOf('month'),
            moment().subtract(1, 'month').endOf('month'),
          ],
        },
      },
      updatePreview
    );

    pickerRef.current = $btn.data('daterangepicker');
    updatePreview(start, end);
  }, [onDateChange]);

  // ⬅️ Go to previous month
  const goToPreviousMonth = () => {
    if (pickerRef.current) {
      const currentStart = moment(pickerRef.current.startDate);
      const newStart = currentStart.subtract(1, 'month').startOf('month');
      const newEnd = newStart.clone().endOf('month');
      pickerRef.current.setStartDate(newStart);
      pickerRef.current.setEndDate(newEnd);
      updatePreview(newStart, newEnd);
    }
  };

  // ➡️ Go to next month
  const goToNextMonth = () => {
    if (pickerRef.current) {
      const currentStart = moment(pickerRef.current.startDate);
      const nextMonthStart = currentStart.clone().add(1, 'month').startOf('month');

      // ✅ Block future months
      if (nextMonthStart.isAfter(moment(), 'month')) return;

      const newStart = nextMonthStart;
      const newEnd = moment.min(newStart.clone().endOf('month'), moment()); // Don’t go beyond today
      pickerRef.current.setStartDate(newStart);
      pickerRef.current.setEndDate(newEnd);
      updatePreview(newStart, newEnd);
    }
  };


  // 🔄 Preview update function (used manually)
  const updatePreview = (start, end) => {
    const $btn = $(buttonRef.current);
    $btn.find('.js-daterangepicker-predefined-preview').html(
      start.format('MMM D') + ' - ' + end.format('MMM D, YYYY')
    );
  };

  return (
    <>
      <style>
        {`
  .daterangepicker td.off.disabled,
  .daterangepicker td.disabled {
    background-color: #f2f2f2 !important;
    color: #aaa !important;
    border-radius: 0px !important;
    cursor: not-allowed !important;
    text-decoration: none !important;
  }
`}
      </style>

      <div className="d-flex align-items-center space-x-2 datepickercalendar">
        <button onClick={goToPreviousMonth} className="arrowLeft" style={{ background: "#fff", display: 'flex', padding: '6px 15px', alignItems: 'center', justifyContent: 'center', width: '50px', border: '1px solid rgba(229, 232, 235, 1)', borderRadius: '20px', height: '38px', }}>
          <ArrowBackIosIcon sx={{ width: '15px', height: '15px' }} />
        </button>

        <button style={{ background: "#fff", display: 'flex', fontSize: '14px', padding: '6px 15px', alignItems: 'center', justifyContent: 'center', width: '257px', border: '1px solid rgba(229, 232, 235, 1)', borderRadius: '20px', height: '38px', }}
          ref={buttonRef}
          className="btn btn-ghost-secondary btn-s js-daterangepicker-predefined position-relative"
        >
          <span className="js-daterangepicker-predefined-preview ms-1" style={{ paddingRight: '40px' }}></span>
          <CalendarIcon style={{ position: 'absolute', right: '13px', top: '50%', transform: 'translateY(-50%)', }} />
        </button>

        <button onClick={goToNextMonth} className="arrowRight" style={{ background: "#fff", display: 'flex', padding: '6px 15px', alignItems: 'center', justifyContent: 'center', width: '50px', border: '1px solid rgba(229, 232, 235, 1)', borderRadius: '20px', height: '38px', }}>
          <ArrowForwardIosIcon sx={{ width: '15px', height: '15px' }} />
        </button>
      </div>
    </>

  );
};
export default DateRangePicker;
